import {formatDate} from '@angular/common';
import {Inject, Injectable, LOCALE_ID} from '@angular/core';
import {SortDirection} from '@angular/material/sort';
import {
    FieldUiDataObj,
    GridColumn,
    MxGeneratorService,
    MxReportFieldsConverterService,
    MxUtilsService,
    ReportCellObj,
    ReportUiDataObj
} from 'mx-core';

export interface FilterForm {
    field: string;
    value: any;
}

@Injectable({
    providedIn: 'root'
})
export class PrlGeneratorService implements MxGeneratorService {

    constructor(private utils: MxUtilsService,
                @Inject(LOCALE_ID) private locale: string,
                private reportFieldsConverterService: MxReportFieldsConverterService) {
    }

    public getColumnsArray(columnDataArray: Array<ReportUiDataObj>,
                           customColumns?: Array<GridColumn>,
                           reportName?: string): Array<GridColumn> {
        return [];
    }

    getGridLinesArray(gridDataArray: ReportCellObj[][]): Array<any> {
        return [];
    }

    getGridLinesQueryParamsArray(gridLines: ReadonlyArray<any>, formPayload: any, columns: ReadonlyArray<GridColumn>,
                                 sortBy: string, sortDirection: SortDirection): Array<any> {
        return [];
    }

    trimAbsentInputFieldsFromQueryParams(queryParams: any, input: Array<ReportUiDataObj>): any {
        return {};
    }

    getFiltersFromGraphFormData(graphInput: ReportUiDataObj[], dynamicFields: FieldUiDataObj[], formData?: any): Array<FilterForm> {
        let filters = [];

        graphInput.forEach(field => {
            if (this.reportFieldsConverterService.isDateRange(field)) {
                let fieldName = field.field;

                if (formData && formData.hasOwnProperty(fieldName)) {
                    filters.push({
                        field: fieldName,
                        value: formData[fieldName + '_list']
                    });
                    filters.push({
                        field: fieldName + '_list',
                        value: formData[fieldName + '_list']
                    });
                    filters.push({
                        field: fieldName + '_from',
                        value: formatDate(formData[fieldName + '_from'], 'yyyy-MM-dd', this.locale)
                    });
                    filters.push({
                        field: fieldName + '_to',
                        value: formatDate(formData[fieldName + '_to'], 'yyyy-MM-dd', this.locale)
                    });
                } else {
                    let dynamicField = dynamicFields.find(df => df.name === fieldName);
                    let fieldFrom = dynamicField.sublist[1];
                    let fieldTo = dynamicField.sublist[2] ;

                    filters.push({
                        field: fieldName,
                        value: dynamicField.defaultValue
                    });
                    filters.push({
                        field: fieldName + '_list',
                        value: dynamicField.sublist[0].defaultValue
                    });
                    filters.push({
                        field: fieldName + '_from',
                        value: formatDate(fieldFrom.defaultValue, 'yyyy-MM-dd', this.locale)
                    });
                    filters.push({
                        field: fieldName + '_to',
                        value: formatDate(fieldTo.defaultValue, 'yyyy-MM-dd', this.locale)
                    });
                }
            } else {
                let filterName = field.field;
                let filterValue = formData && formData.hasOwnProperty(filterName)
                    ? formData[filterName]
                    : dynamicFields.find(df => df.name === filterName).defaultValue;
                if (filterValue === '') {
                    filterValue = null;
                }
                filters.push({field: filterName, value: filterValue});
            }
        });

        return filters;
    }

}
